import AllCards from "./components/AllCards";


export default function App() {
  return (

    <>
      <AllCards />

    </>

  )
}